import React, { useEffect } from 'react';
import { Modal, Button, Icon } from 'antd';
import { ModalBody } from './styles';

import { withTranslation } from 'react-i18next';
import { TEMPLATE_LOCK_MODAL } from '../TemplateLock/translationValues';
const NAMESPACES = ['TEMPLATE_LOCK_MODAL'];

const UserInactivityModal = props => {
  const { open, stayInDesignArea, closeDesign, maxIdleTime = 30, t } = props;
  useEffect(() => {
    
    const timer = setTimeout(() => closeDesign(), 60000); /// 1 minute

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <Modal
      title={''}
      centered
      width="625px"
      visible={open}
      closable={false}
      maskClosable={false}
      footer={[
        <Button key="submit" type="primary" onClick={() => stayInDesignArea()}>
          {t(TEMPLATE_LOCK_MODAL.STAY_BUTTON.key, TEMPLATE_LOCK_MODAL.STAY_BUTTON.value)}
        </Button>,
        <Button key="submit" type="primary" onClick={() => closeDesign()}>
          {t(TEMPLATE_LOCK_MODAL.LOCKED_MODAL_OK_BUTTON.key, TEMPLATE_LOCK_MODAL.LOCKED_MODAL_OK_BUTTON.value)}
        </Button>,
      ]}
    >
      <ModalBody>
        <div className="warning-text inactivity">
          <Icon type="warning" />
          <span>
            {t(TEMPLATE_LOCK_MODAL.INACTIVE_MESSAGE.key, TEMPLATE_LOCK_MODAL.INACTIVE_MESSAGE.value, { maxIdleTime })}
          </span>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default withTranslation(NAMESPACES)(UserInactivityModal);
